var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-menu",
    {
      staticClass: "ui-menu",
      attrs: {
        "md-direction": _vm.direction,
        "md-size": _vm.size,
        "md-close-on-click": "",
      },
    },
    [
      _c("ui-button", {
        attrs: { icon: _vm.icon, text: _vm.label, "md-menu-trigger": "" },
      }),
      _vm._v(" "),
      _c(
        "md-menu-content",
        { staticStyle: { "max-height": "calc(100vh - 48px)" } },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _vm.tooltip
        ? _c("md-tooltip", { staticClass: "ui-menu-tooltip" }, [
            _vm._v("\n\t\t" + _vm._s(_vm.tooltip) + "\n\t"),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }